import React from "react";
import { Grid } from 'semantic-ui-react';
import { Link } from "react-router-dom";

const DefaultCheckAvailabilityFooter = () => {
  return (
    <Grid className="bg--grey footer__check-availability mx-0" textAlign='center'>
      <div className="ui text menu">
        <Link to={'support'} className="item">Contact Us</Link>
        <Link to={'faqs'} className="item">Faqs</Link>  
      </div>
    </Grid>
  )

}

export default DefaultCheckAvailabilityFooter;


// WEBPACK FOOTER //
// ./src/components/footer/DefaultCheckAvailabilityFooter.js